import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import StudentWrapper from '../../StudentWrapper';
import AddCources from '../../Cources/AddCources';
import Input from '../../../components/Input';

const MyCources = () => {
  const [open, setOpen] = useState(false);
  const [course, setCourse] = useState([]);
  const [myenrollment, setMyenrollment] = useState('');
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCourses = course.filter((course) => {
    const matchesSearchQuery =
      course?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      course?.course?.name?.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearchQuery;
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('userData'));
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      email: user?.email
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/user/my-course', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log('DATA', data);
        
       
        if (data?.success === true) {
          setCourse(data?.data);
        }else{
          setCourse([]);
        }
        setLoading(false); // Set loading to false when data is fetched
      })
      .catch((error) => {
        console.error(error);
        setLoading(false); // Set loading to false in case of error
      });
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    let data = JSON.parse(userData);

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      email: data?.email
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/user/my-course', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("DATA", data.data);
        setMyenrollment(data?.data?.length);
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <StudentWrapper
      searchBar={
        <Input
          placeholder={`Search by  course name...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img
              src={require('../../../assets/image/Search-Magnifier.png')}
              className=" w-8"
              alt=""
            />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <AddCources setIsModalOpen={setOpen} isModalOpen={open} />
      <div className="flex justify-between items-center">
        <div>
          <h2 className="main_title">Cources</h2>
          <p className="text-[#1C1D1D]">Here overview of the courses</p>
        </div>
        <div></div>
      </div>

      <section>
        {loading ? ( // Show loading if data is still being fetched
          <div className="text-center py-4">Loading...</div>
        ) : (
          <div className="grid grid-cols-2 mt-4 gap-6">
            {filteredCourses?.map((item, index) => (
              <Link
                key={index}
                to={`/enrolled-cource-details/${item?.course?._id}`}
                className="bg-white p-5 items-center flex md:flex-row flex-col rounded-lg gap-4"
                style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
              >
                <div className="w-20 h-20 rounded-lg overflow-hidden">
                  <img src={item?.course?.image} className="w-full h-full" alt={item.courseName} />
                </div>
                <div>
                  <h6 className="text-lg flex gap-3">
                    {item.courseName}{' '}
                    <img src={require('../../../assets/image/LockSimple.png')} alt="Lock" />
                  </h6>
                  <div className="flex gap-5 pt-2 items-center">
                    <div className="flex gap-1 items-center ">
                      <div>
                        <img src={require('../../../assets/image/Clock.png')} alt="Clock" />
                      </div>
                      <p>{item?.course?.duration || 'N/A'}</p>
                      <p>{item?.course?.periodType || 'N/A'}</p>
                    </div>

                    <div className="flex gap-1 items-center">
                      <p>
                        Payment:{' '}
                        <span
                          className={`text-sm ${
                            item.paymentStatus === 'pending'
                              ? 'text-[red]'
                              : item.paymentStatus === 'approved'
                                ? 'text-[green]'
                                : item.paymentStatus === 'inactive'
                                  ? 'text-[yellow]'
                                  : ''
                          }`}
                        >
                          {item.paymentStatus
                            .split(' ')
                            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' ')}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </StudentWrapper>
  );
};

export default MyCources;
